export const ItemAvailabilityStatus = Object.freeze({
  AVAILABLE: 'AVAILABLE',
  DEGRADED: 'DEGRADED',
  DEPRECATED: 'DEPRECATED',
  UNAVAILABLE: 'UNAVAILABLE'
})
